import React, { useState } from "react";
import { axiosPost } from "../../../utils/AxiosApi";
import { URL } from "../../../utils/Constants";
import { useARRCode } from "../context/ARRLevelContext";
import swal from "sweetalert";

export const useSelectClassrooms = () => {
  const [classrooms, setClassrooms] = useState([]);
  const [classroomLoading, setClassroomLoading] = useState(false);

  const getClassrooms = (id) => {
    setClassroomLoading(true);
    axiosPost(
      URL.selectClassroom,
      { yearLevelId: id },
      (response) => {
        if (response?.status === 200) {
          const data = response?.data?.data;
          const processedData = data?.map((item) => ({
            label: item?.name,
            value: item?.id,
          }));
          setClassrooms(processedData);
        }
        setClassroomLoading(false);
      },
      (error) => {
        setClassroomLoading(false);
      },
    );
  };

  return { classrooms, classroomLoading, getClassrooms };
};

export const useSubjectsByYearLevel = () => {
  const { arrLevel } = useARRCode();
  const [subjects, setSubjects] = useState([]);

  const getSubjectsByYearLevel = (params) => {
    const payload = { ...params, getSubjectsByYearLevel: arrLevel };
    axiosPost(URL.getFilteredSubjectByYearLevel, payload, (response) => {
      if (response.status === 200) {
        const data = response?.data?.data;
        const processedData = data?.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
        setSubjects(processedData);
      }
    });
  };

  return { subjects, getSubjectsByYearLevel };
};

export const useStudents = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAllStudents = (params) => {
    setLoading(true);
    axiosPost(
      URL.getAllStudents,
      params,
      (response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          const processedData = data?.map((item) => ({
            id: item?.admissionId,
            name: item?.people?.name,
            gender: item?.people?.gender,
            dateOfBirth: item?.people?.dateOfBirth,
            rollNumber: item?.rollNumber,
            photo: item?.people?.photo,
            peopleId: item?.people?.id,
            symbolNo: item?.customValues?.symbolNo,
            registrationNumber: item?.customValues?.registrationNumber,
          }));
          setStudents(processedData);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
      },
    );
  };

  return { loading, students, setStudents, getAllStudents };
};

export const useStudentOptionalSubjects = () => {
  const { arrLevel } = useARRCode();
  const [loading, setLoading] = useState({
    insert: false,
    read: false,
    delete: false,
  });
  const [studentsOptionalSubject, setStudentsOptionalSubject] = useState([]);

  const insertStudentClassroomOptionalSubject = (payload) => {
    setLoading((prev) => ({ ...prev, insert: true }));
    return new Promise((resolve, reject) => {
      axiosPost(
        URL.insertStudentClassroomOptionalSubject,
        payload,
        (response) => {
          if (response.status === 200) {
            swal("Success", "Successfully assigned optional subjects");
            resolve(response);
          } else {
            reject(response);
          }
          setLoading((prev) => ({ ...prev, insert: false }));
        },
        (error) => {
          setLoading((prev) => ({ ...prev, insert: false }));
          swal(
            "Oops",
            error?.response?.data?.message ||
              "Failed to assign optional subjects",
          );
          reject(error);
        },
      );
    });
  };

  const selectStudentClassroomOptionalSubject = (params) => {
    const payload = { ...params, assessmentModuleCode: arrLevel };
    setLoading((prev) => ({ ...prev, read: true }));
    axiosPost(
      URL.selectStudentClassroomOptionalSubject,
      payload,
      (response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          setStudentsOptionalSubject(data);
        }
        setLoading((prev) => ({ ...prev, read: false }));
      },
      (error) => {
        setLoading((prev) => ({ ...prev, read: false }));
      },
    );
  };

  const deleteStudentClassroomOptionalSubject = (params) => {
    setLoading((prev) => ({ ...prev, delete: true }));
    return new Promise((resolve, reject) => {
      axiosPost(
        URL.deleteStudentClassroomOptionalSubject,
        params,
        (response) => {
          if (response.status === 200) {
            swal("Success", "Successfully unassigned optional subjects");
            resolve(response);

            const selectParams = {
              classroomId: params.classroomId,
              educationLevelDivisionId: params.educationLevelDivisionId,
              educationLevelId: params.educationLevelId,
              yearLevelId: params.yearLevelId,
            };
            selectStudentClassroomOptionalSubject(selectParams);
          } else {
            reject(response);
          }
          setLoading((prev) => ({ ...prev, delete: false }));
        },
        (error) => {
          swal(
            "Oops",
            error?.response?.data?.message ||
              "Failed to unassign optional subjects",
          );
          setLoading((prev) => ({ ...prev, delete: false }));
          reject(error);
        },
      );
    });
  };

  return {
    studentsOptionalSubject,
    loading,
    setStudentsOptionalSubject,
    insertStudentClassroomOptionalSubject,
    selectStudentClassroomOptionalSubject,
    deleteStudentClassroomOptionalSubject,
  };
};
